import { useEffect } from "react";
import * as React from "react";

// actions
import { handleInitialAuth } from "./select-client-interface";

const SelectAuthAllView: React.FC = () => {
  useEffect(() => {
    handleInitialAuth();
  }, []);

  return (
    <div
      className="selectAuth-all-view"
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        paddingTop: "50px",
      }}
    >
      <h1 style={{ fontFamily: "SynchronySans", fontSize: "32px" }}>
        You are being logged in with Okta...
      </h1>
    </div>
  );
};

export default SelectAuthAllView;
